import HyperLink from './HyperLink';

export default HyperLink;
